export const PHONE_DISPLAY = "+91 77991 57203 · +91 95502 35424";
export const PHONE_TEL = "tel:+917799157203";
export const WHATSAPP_LINK = `https://wa.me/917799157203?text=${encodeURIComponent(
    "Hello Zam Zam Furnitures, I'd like a factory-direct bulk quote for office furniture."
)}`;
export const ADDRESS = "7-8-1830, Fateh Bagh, Erragadda, Sanath Nagar Industrial Estate, Hyderabad, Telangana – 500018";
export const EMAIL = "zzfurnitures@gmail.com";
export const DOMAIN = "zzfurnitures.com";

const U = (id) => id; // urls already fully formed

export const IMAGES = {
    hero: U("https://images.unsplash.com/photo-1631193816258-28b44b21e78b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3RhdGlvbnN8ZW58MHx8fHwxNzg3OTk5NDAwfDA&ixlib=rb-4.1.0&q=85"),
    workstations: U("https://images.unsplash.com/photo-1718220216044-006f43e3a9b1?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDJ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBvZmZpY2UlMjB3b3Jrc3RhdGlvbnN8ZW58MHx8fHwxNzg3OTk5NDAwfDA&ixlib=rb-4.1.0&q=85"),
    executive: U("https://images.unsplash.com/photo-1518455027359-f3f8164ba6bd?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwzfHxvZmZpY2UlMjBmdXJuaXR1cmUlMjBjaGFpcnMlMjBkZXNrc3xlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
    chairs: U("https://images.unsplash.com/photo-1688578735427-994ecdea3ea4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHwyfHxvZmZpY2UlMjBmdXJuaXR1cmUlMjBjaGFpcnMlMjBkZXNrc3xlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
    conference: U("https://images.unsplash.com/photo-1571624436279-b272aff752b5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwxfHxjb25mZXJlbmNlJTIwdGFibGUlMjBvZmZpY2V8ZW58MHx8fHwxNzg3OTk5NDAwfDA&ixlib=rb-4.1.0&q=85"),
    storage: U("https://images.unsplash.com/photo-1779700314631-1f18b467e0a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
    reception: U("https://images.unsplash.com/photo-1758448093806-88b2089068ab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwyfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
    factory: U("https://images.unsplash.com/photo-1553051021-9f94520a6cad?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwzfHxmdXJuaXR1cmUlMjBtYW51ZmFjdHVyaW5nJTIwZmFjdG9yeSUyMHdvb2R8ZW58MHx8fHwxNzg3OTk5MzkyfDA&ixlib=rb-4.1.0&q=85"),
    gallery1: U("https://images.unsplash.com/photo-1758448656987-cfae6bf225e4?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
    gallery2: U("https://images.unsplash.com/photo-1779700314631-1f18b467e0a7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTF8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBjb3Jwb3JhdGUlMjBvZmZpY2UlMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODc5OTkzOTJ8MA&ixlib=rb-4.1.0&q=85"),
};

export const CATEGORIES = [
    {
        id: "workstations",
        num: "01",
        name: "Modular Workstations & Cubicles",
        blurb: "Cluster desks, linear stations and collaborative bays engineered for high-density corporate floors.",
        items: ["Cluster workstations", "Linear benching systems", "Collaborative bays"],
        image: IMAGES.workstations,
        span: "lg:col-span-8",
    },
    {
        id: "executive",
        num: "02",
        name: "Executive & Boss Desks",
        blurb: "Premium veneer and laminate desks, director suites and manager tables.",
        items: ["Veneer director desks", "Manager tables", "Side units & returns"],
        image: IMAGES.executive,
        span: "lg:col-span-4",
    },
    {
        id: "chairs",
        num: "03",
        name: "Ergonomic Office Chairs",
        blurb: "Mesh task chairs, executive seating and visitor chairs under the TASKLANCE® standard.",
        items: ["Mesh task chairs", "Executive seating", "Visitor chairs"],
        image: IMAGES.chairs,
        span: "lg:col-span-4",
    },
    {
        id: "conference",
        num: "04",
        name: "Conference & Meeting Tables",
        blurb: "Boardroom tables and modular meeting setups with integrated power.",
        items: ["Boardroom tables", "Modular meeting pods", "Cable management"],
        image: IMAGES.conference,
        span: "lg:col-span-4",
    },
    {
        id: "storage",
        num: "05",
        name: "Storage & Filing Solutions",
        blurb: "Pedestals, metal cabinets and wooden credenzas for commercial storage.",
        items: ["Mobile pedestals", "Metal filing cabinets", "Wooden credenzas"],
        image: IMAGES.storage,
        span: "lg:col-span-4",
    },
    {
        id: "reception",
        num: "06",
        name: "Reception & Breakout Furniture",
        blurb: "Front desks, lounge seating and cafeteria tables that set the first impression.",
        items: ["Reception desks", "Lounge seating", "Cafeteria tables"],
        image: IMAGES.reception,
        span: "lg:col-span-12",
    },
];

export const VALUES = [
    {
        num: "01",
        title: "Direct Manufacturer Pricing",
        desc: "No middlemen, no dealer margins. You buy at the factory gate in Erragadda — the price we quote is the price we make it for.",
    },
    {
        num: "02",
        title: "Custom Workspace Design",
        desc: "Tailored modular layouts for offices of any size, planned around your floor plate, headcount and growth plan.",
    },
    {
        num: "03",
        title: "Ergonomic & Durable",
        desc: "High-grade boards, hardware and mesh built for long-term commercial use under the TASKLANCE® quality standard.",
    },
    {
        num: "04",
        title: "Fast Delivery & On-Site Setup",
        desc: "Our own installation team delivers, assembles and levels every workstation across Telangana and Andhra Pradesh.",
    },
];

export const CAPABILITIES = [
    "Bulk corporate orders — 10 to 1,000+ seats per floor",
    "Custom dimensions, laminates and edge profiles",
    "Color matching to your brand palette",
    "Space planning assistance for architects & interior contractors",
    "OEM production runs for dealers and fit-out firms",
];

export const PROJECTS = [
    { image: IMAGES.gallery1, title: "IT Park Floor Fit-Out", meta: "420 workstations · Hyderabad" },
    { image: IMAGES.conference, title: "Corporate Boardroom Suite", meta: "Veneer boardroom system · Banjara Hills" },
    { image: IMAGES.reception, title: "Headquarters Reception", meta: "Custom front desk & lounge · HITEC City" },
    { image: IMAGES.workstations, title: "Co-Working Campus", meta: "Linear benching · Bengaluru corridor" },
];

export const REQUIREMENT_TYPES = [
    "Modular Workstations",
    "Office Chairs",
    "Executive Desks",
    "Conference Tables",
    "Storage Solutions",
    "Full Office Setup",
];

export const CHAIR_CATEGORIES = [
    {
        id: "workstation",
        label: "Workstation Chairs",
        tagline: "Mid-back mesh task chairs built for daily 8+ hour use on IT and corporate floors.",
        chairs: [
            {
                name: "Jazz MB", model: "TLC636", series: "MID BACK", img: "/products/chairs/jazz-mb-tlc636.png",
                features: [
                    "Ergonomically designed mesh back with lumbar support adjustment",
                    "Adjustable PP armrests",
                    "Centre-tilt mechanism with upright lock",
                    "Nylon 5-star base with twin-wheel castors",
                    "Hydraulic gas lift height adjustment · 360° revolving",
                ],
                materials: "Breathable nylon mesh back · Moulded PU foam seat, fabric upholstery",
            },
            {
                name: "Elevate MB", model: "TLC620", series: "MID BACK", img: "/products/chairs/elevate-mb-tlc620.png",
                features: [
                    "Ergonomic X-frame back with lumbar support adjustment",
                    "Fixed PP armrests",
                    "Tilt mechanism with tension control",
                    "Nylon base with 50mm castor wheels",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Nylon mesh back · High-density moulded foam seat",
            },
            {
                name: "Sigma MB", model: "TLC638", series: "MID BACK", img: "/products/chairs/sigma-mb-tlc638.png",
                features: [
                    "Ergonomic X-frame back with lumbar support adjustment",
                    "Height-adjustable armrests",
                    "Synchro-tilt mechanism with single-point lock",
                    "Nylon base with castor wheels",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Mesh back with colour-accent frame options · Moulded foam seat",
            },
            {
                name: "Saturn MB", model: "TLC629", series: "MID BACK", img: "/products/chairs/saturn-mb-tlc629.png",
                features: [
                    "Ergonomic back with pronounced lumbar cradle, adjustable",
                    "Adjustable armrests",
                    "Tilt mechanism with upright lock",
                    "Nylon base with twin-wheel castors",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Dual-tone mesh back · Dual-density moulded foam seat",
            },
            {
                name: "Panda MB", model: "TLC648", series: "MID BACK", img: "/products/chairs/panda-mb-tlc648.png",
                features: [
                    "Ergonomic perforated back with lumbar pad",
                    "Fixed designer armrests",
                    "Tilt mechanism with upright lock",
                    "Nylon / chrome base options with castors",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Perforated polymer back · Colour cushion seat options",
            },
        ],
    },
    {
        id: "manager",
        label: "Manager Chairs",
        tagline: "High-back chairs with headrests for cabin and team-lead seating.",
        chairs: [
            {
                name: "Saturn HB", model: "TLC729", series: "HIGH BACK", img: "/products/chairs/saturn-hb-tlc729.png",
                features: [
                    "Ergonomically designed high back with lumbar support adjustment",
                    "Adjustable headrest + adjustable armrests",
                    "Synchro-tilt mechanism with multi-point lock",
                    "Heavy-duty nylon base with twin-wheel castors",
                    "Class-4 hydraulic gas lift · 360° revolving",
                ],
                materials: "Premium nylon mesh back · Moulded PU foam seat, fabric upholstery",
            },
            {
                name: "Mentor HB", model: "TLC708", series: "HIGH BACK", img: "/products/chairs/mentor-hb-tlc708.png",
                features: [
                    "Tall ergonomic back with lumbar support adjustment",
                    "Integrated cushioned headrest",
                    "Adjustable armrests",
                    "Tilt mechanism with upright lock",
                    "Nylon base, castors · Hydraulic gas lift · 360° revolving",
                ],
                materials: "Fine nylon mesh back · High-resilience moulded foam seat",
            },
            {
                name: "Pluto HB", model: "TLC728", series: "HIGH BACK", img: "/products/chairs/pluto-hb-tlc728.png",
                features: [
                    "Ergonomic ribbed-mesh back with lumbar support adjustment",
                    "Adjustable headrest",
                    "Fixed PP armrests",
                    "Tilt mechanism with tension control",
                    "Nylon base, castors · Hydraulic gas lift · 360° revolving",
                ],
                materials: "Ribbed nylon mesh · Deep-cushion moulded foam seat",
            },
            {
                name: "Marvel HB", model: "TLC726", series: "HIGH BACK", img: "/products/chairs/marvel-hb-tlc726.png",
                features: [
                    "Ergonomic contoured back with dial lumbar support adjustment",
                    "Adjustable armrests + headrest",
                    "Synchro-tilt mechanism",
                    "Nylon / chrome base with castor wheels",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Contour mesh back · Moulded PU foam seat with fabric",
            },
        ],
    },
    {
        id: "md",
        label: "MD Chairs",
        tagline: "Premium executive high-backs for director cabins and boardrooms.",
        chairs: [
            {
                name: "Butterfly HB", model: "TLC635", series: "HIGH BACK · EXECUTIVE", img: "/products/chairs/butterfly-hb-tlc635.png",
                features: [
                    "Ergonomic winged back with lumbar support adjustment",
                    "Wide adjustable armrests",
                    "Knee-tilt synchro mechanism with multi-lock",
                    "Aluminium-detailed nylon base with castors",
                    "Class-4 hydraulic gas lift · 360° revolving",
                ],
                materials: "Premium wide-weave mesh · Extra-wide moulded foam seat",
            },
            {
                name: "Optima HB", model: "TLC707", series: "HIGH BACK · EXECUTIVE", img: "/products/chairs/optima-hb-tlc707.png",
                features: [
                    "Slim ergonomic back with lumbar support adjustment",
                    "Adjustable armrests + headrest",
                    "Synchro-tilt mechanism",
                    "Polished chrome base with castor wheels",
                    "Hydraulic gas lift · 360° revolving · Optional coat hanger",
                ],
                materials: "Fine mesh back · Moulded foam seat, premium fabric",
            },
            {
                name: "Fedo", model: "TLC732", series: "HIGH BACK · EXECUTIVE", img: "/products/chairs/fedo-tlc732.png",
                features: [
                    "Executive ergonomic back with lumbar support adjustment",
                    "Cushioned fixed armrests",
                    "Synchro-tilt mechanism with tension control",
                    "Polished aluminium base with castors",
                    "Hydraulic gas lift · 360° revolving",
                ],
                materials: "Slate-grey executive mesh · Moulded foam seat",
            },
        ],
    },
    {
        id: "visitor",
        label: "Visitor & Fixed Chairs",
        tagline: "Fixed-frame chairs for waiting areas, meeting rooms and visitor seating.",
        chairs: [
            {
                name: "S04 VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/s04-vc.png",
                features: [
                    "Ergonomically designed mesh back with lumbar support",
                    "Fixed PP armrests",
                    "Fixed cantilever sled base — no castors, no hydraulics",
                    "Non-revolving fixed frame for waiting areas",
                ],
                materials: "Nylon mesh back · Moulded PU foam seat · Black MS frame",
            },
            {
                name: "Honda VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/honda-vc.png",
                features: [
                    "Ergonomic slatted back with lumbar support",
                    "Fixed PP armrests",
                    "Chrome-finish MS cantilever frame",
                    "Fixed, non-revolving — floor-friendly glides",
                ],
                materials: "Ventilated slat back · Fabric-upholstered foam seat",
            },
            {
                name: "Kabeel VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/kabeel-vc.png",
                features: [
                    "Ergonomic flex-slat back with lumbar support",
                    "Fixed designer armrests",
                    "Chrome cantilever sled base",
                    "Fixed frame — no castors or hydraulics",
                ],
                materials: "Flex-slat polymer back · Moulded foam seat, fabric",
            },
            {
                name: "Jazz VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/jazz-vc.png",
                features: [
                    "Ergonomic mesh back with lumbar support",
                    "Adjustable-look fixed armrests",
                    "Black MS cantilever frame",
                    "Fixed, non-revolving visitor format",
                ],
                materials: "Nylon mesh back · Moulded PU foam seat, fabric upholstery",
            },
            {
                name: "Z1S1 VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/z1s1-vc.png",
                features: [
                    "Ergonomic ribbed back with lumbar support",
                    "Fixed cushioned armrests",
                    "Chrome cantilever sled base",
                    "Fixed frame for meeting & reception areas",
                ],
                materials: "Ribbed polymer back · Fabric cushioned seat",
            },
            {
                name: "Vista VC", model: "VISITOR · FIXED", series: "VISITOR", img: "/products/chairs/vista-vc.png",
                features: [
                    "Cushioned ergonomic back with lumbar contour",
                    "Fixed cushioned armrests",
                    "Black powder-coated MS sled frame",
                    "Fixed, non-revolving — reception grade",
                ],
                materials: "Leatherette / fabric cushioned back & seat",
            },
        ],
    },
];

export const CATALOGS = [
    {
        title: "Office Chairs",
        category: "Seating",
        meta: "Task · Manager · MD · Visitor Chairs · 16 Pages",
        href: "/catalogs/TASKLANCE-Office-Chairs.pdf",
    },
    {
        title: "Bar Chairs",
        category: "Seating",
        meta: "Bar & Counter Stools · 11 Pages",
        href: "/catalogs/TASKLANCE-Bar-Chairs.pdf",
    },
    {
        title: "Dining Chairs",
        category: "Dining & Café",
        meta: "Dining & Restaurant Chairs · 16 Pages",
        href: "/catalogs/TASKLANCE-Dining-Chairs.pdf",
    },
    {
        title: "Cafe Tables",
        category: "Dining & Café",
        meta: "Café, Bistro & Canteen Tables · 18 Pages",
        href: "/catalogs/TASKLANCE-Cafe-Tables.pdf",
    },
    {
        title: "Premium Sofas",
        category: "Sofas & Lounge",
        meta: "Office Sofas & Lounge Seating · 46 Pages",
        href: "/catalogs/TASKLANCE-Premium-Sofas.pdf",
    },
];
